import { API_ROUTES } from '../config/api';
import api from './api';
import { 
  OutstockDeclaration, 
  OutstockDeclarationsListParams 
} from '../types/outstock';

export const fetchSimilarItems = async (databaseId: string, productId: string, similarProductsNbr?: number) => {
  const response = await api.post(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.SIMILAR_ITEMS(databaseId), {
    product_id: productId,
    similar_products_nbr: similarProductsNbr
  });
  return response.data;
};

export const createOutstockDeclaration = async (databaseId: string, data: {
  product_id: string;
  start_date: string;
  end_date: string;
  products: [string, number][];
}) => {
  const response = await api.post(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.DECLARATIONS(databaseId), data);
  return response.data;
};

export const createOutstockCorrection = async (databaseId: string, data: {
  article_id: string;
  correction_date: string;
  quantity: number;
  declaration_id: string;
}) => {
  const response = await api.post(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.CORRECTIONS(databaseId), data);
  return response.data;
};

export const updateOutstockCorrection = async (databaseId: string, correctionId: string, data: {
  quantity: number;
}) => {
  const response = await api.put(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.CORRECTIONS(databaseId) + correctionId + '/', data);
  return response.data;
};

export const deleteOutstockCorrection = async (databaseId: string, correctionId: string) => {
  await api.delete(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.CORRECTIONS(databaseId) + correctionId + '/');
};

export const listOutstockCorrections = async (
  databaseId: string,
  params?: { declaration_id?: string; article_id?: string }
) => {
  const response = await api.get(
    API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.CORRECTIONS(databaseId),
    { params }
  );
  return response.data as Array<{
    id: number;
    article_id: string;
    correction_date: string;
    quantity: number;
  }>;
};

export const listOutstockDeclarations = async (databaseId: string, params?: OutstockDeclarationsListParams) => {
  const response = await api.get(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.DECLARATIONS_LIST(databaseId), { params });
  return response.data;
};

type UpdateOutstockDeclarationBody = Partial<OutstockDeclaration> & { products?: [string, number][] };

export const updateOutstockDeclaration = async (databaseId: string, declarationId: string, data: UpdateOutstockDeclarationBody) => {
  const response = await api.put(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.DECLARATION_DETAIL(databaseId, declarationId), data);
  return response.data;
};

export const deleteOutstockDeclaration = async (databaseId: string, declarationId: string) => {
  await api.delete(API_ROUTES.OUTSTOCK.BASE + API_ROUTES.OUTSTOCK.DECLARATION_DELETE(databaseId, declarationId));
};